module.exports = __webpack_public_path__ + "static/grafika1-24dc4398763bc3ebcbf6db6dcc0e5536.png";